module.exports = __webpack_public_path__ + "img/bat.9acf556b.png";